import React from "react";
import EdButton, {
  IEdButtonProps,
} from "@/components/generic/edbutton/edButton";
import ThreeDotLoader from "@/components/generic/ThreeDotLoader";

export interface ITwinBtnsProps {
  leftBtn?: IEdButtonProps & ITwinButtonHelper;
  rightBtn?: IEdButtonProps & ITwinButtonHelper;
  parentClass?: string;
}

interface ITwinButtonHelper {
  threeDotLoader?: boolean;
}

const TwinButtonHelper = (properties: IEdButtonProps & ITwinButtonHelper) => {
  return (
    <EdButton
      btnTyp={properties?.btnTyp}
      value={properties.threeDotLoader ? <ThreeDotLoader /> : properties?.value}
      disabled={!!properties?.disabled}
      className={properties?.className}
      onClick={(e) => properties?.onClick(e)}
    />
  );
};

const TwinBtns = (props: ITwinBtnsProps) => {
  return (
    <div className={props?.parentClass ?? ""}>
      {props?.leftBtn && <TwinButtonHelper {...props?.leftBtn} />}
      {props?.rightBtn && <TwinButtonHelper {...props?.rightBtn} />}
    </div>
  );
};

export default TwinBtns;
